import { Component, h } from '@stencil/core';
import infoSvg from '@se/icons/svg/information_stroke.svg';

@Component({
  tag: 'rt-info',
  styleUrl: 'info.scss',
  shadow: true,
})
export class Info {
  render() {
    return (
      <div class="info">
        <span class="info-icon" innerHTML={infoSvg}></span>
        <slot name="info"></slot>
        <slot></slot>
      </div>
    );
  }
}
